import React from "react";
import CaprimMapamundi from "../../../assets/images/brand/caprim-mapamundi.jpg";

const Footertwo = () => {
  return (
    <>
      <footer className="footer-two footer-two--mapa">
        <div className="footer-two-mapa-frame">
          <img
            className="footer-two-mapa-img"
            src={CaprimMapamundi}
            alt="Caprim"
          />
          <div className="footer-two-mapa-copyright">
            <p>
              Copyright © 2026 Caprimtech SAS.&nbsp;Todos los derechos reservados
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};
export default Footertwo;
